'use client';

import { useEffect, useState } from 'react';

import { useLocale, useTranslations } from 'next-intl';

import { LangType } from '@/app/[lang]/_type/lang';
import { getMappedDiffDistance } from '@/app/_helper/time';
import { Property } from '@/modules/core/gql/generated';
import { cn } from '@/app/_helper/tailwind';

type LastUpdateInfoProps = {
    time: Property['time'];
    className?: string;
};

const LastUpdateInfo = ({ time, className }: LastUpdateInfoProps) => {
    const locale = useLocale();
    const t = useTranslations('common');

    const getLastUpdated = () => {
        return getMappedDiffDistance(
            time.posted ? time.posted * 1000 : time.created * 1000,
            locale as LangType,
        );
    };
    const [lastUpdated, setLastUpdated] = useState<string>(getLastUpdated);

    useEffect(() => {
        setLastUpdated(getLastUpdated());
    }, []);

    return (
        <p className={cn('text-3xs text-greyText font-medium', className)}>
            {lastUpdated ? t('updateAt', { value: lastUpdated }) : ''}
        </p>
    );
};

export default LastUpdateInfo;
